<template>
  <div class="wrapper">
      <NavBar class="test"></NavBar>
     <div id="layout-wrapper">

        <div class="topnav">
           <div class="container-fluid">
              <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
                 <div class="collapse navbar-collapse" id="topnav-menu-content">
                    <ul class="navbar-nav">
                       <li class="nav-item dropdown">
                          <router-link :to="{ name: 'servers' }" class="nav-link dropdown-toggle arrow-none" id="topnav-dashboard" role="button" aria-haspopup="true" aria-expanded="false">
                          <i class="bx bxs-home-circle mr-2"></i>Servers
                          </router-link>
                       </li>
                       <li class="nav-item dropdown">
                          <router-link :to="{ name: 'billing' }" class="nav-link dropdown-toggle arrow-none" id="topnav-uielement" role="button" aria-haspopup="true" aria-expanded="false">
                          <i class="bx bxs-credit-card mr-2"></i>Billing
                         </router-link>
                       </li>
                       <li class="nav-item dropdown">
                          <router-link :to="{ name: 'support' }" class="nav-link dropdown-toggle arrow-none" id="topnav-uielement" role="button" aria-haspopup="true" aria-expanded="false">
                          <i class="bx bxs-paper-plane mr-2"></i>Support
                         </router-link>
                       </li>
                    </ul>
                 </div>
              </nav>
           </div>
        </div>
        <!-- ============================================================== -->
        <!-- Start right Content here -->
        <!-- ============================================================== -->
        <div class="main-content">
           <router-view/>
           <!-- End Page-content -->
           <footer class="footer">
              <div class="container-fluid">
                 <div class="row">
                    <div class="col-sm-6">
                       Copyright &copy; SpaceMine Ltd 2017 - {{ year }}. All rights reserved.
                    </div>
                    <div class="col-sm-6">
                       <div class="text-sm-right d-none d-sm-block">
                          Company No. 11084250
                       </div>
                    </div>
                 </div>
              </div>
           </footer>
        </div>
        <!-- end main content-->
     </div>
     <!-- END layout-wrapper -->
     <!-- Right Sidebar -->
     <div class="right-bar">
        <div data-simplebar class="h-100">
           <div class="rightbar-title px-3 py-4">
              <a href="javascript:void(0);" class="right-bar-toggle float-right">
              <i class="mdi mdi-close noti-icon"></i>
              </a>
              <h5 class="m-0">Settings</h5>
           </div>
           <!-- Settings -->
           <hr class="mt-0" />
           <h6 class="text-center mb-0">Choose Layouts</h6>
           <div class="p-4">
              <div class="mb-2">
                 <!-- <img src="../assets/images/layouts/layout-1.jpg"  class="img-fluid img-thumbnail" alt=""> -->
              </div>
              <div class="custom-control custom-switch mb-3">
                 <input type="checkbox" class="custom-control-input theme-choice" id="light-mode-switch" checked />
                 <label class="custom-control-label" for="light-mode-switch">Light Mode</label>
              </div>
              <div class="mb-2">
                 <!-- <img src="../assets/images/layouts/layout-2.jpg" class="img-fluid img-thumbnail" alt=""> -->
              </div>
              <div class="custom-control custom-switch mb-3">
                 <input type="checkbox" class="custom-control-input theme-choice" id="dark-mode-switch" data-bsStyle="../assets/css/bootstrap-dark.min.css" data-appStyle="../assets/css/app-dark.min.css" />
                 <label class="custom-control-label" for="dark-mode-switch">Dark Mode</label>
              </div>
              <div class="mb-2">
                 <!-- <img src="../assets/images/layouts/layout-3.jpg" class="img-fluid img-thumbnail" alt=""> -->
              </div>
              <div class="custom-control custom-switch mb-5">
                 <input type="checkbox" class="custom-control-input theme-choice" id="rtl-mode-switch" data-appStyle="../assets/css/app-rtl.min.css" />
                 <label class="custom-control-label" for="rtl-mode-switch">RTL Mode</label>
              </div>
           </div>
        </div>
        <!-- end slimscroll-menu-->
     </div>
     <!-- /Right-bar -->
     <!-- Right bar overlay-->
     <div class="rightbar-overlay"></div>
  </div>
</template>

<script>
import 'bootstrap'
import store from '../store'
import NavBar from './elements/NavBar.vue'
import jQuery from 'jquery'
window.jQuery = jQuery

export default {
  name: 'Management',
  components: {
    NavBar
  },
  data () {
    return {
      year: (new Date().getFullYear())
    }
  },
  computed:
  {
    name () {
      return store.state.name
    },
    profileImage () {
      return store.state.profileUrl
    }
  }
}</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Management.vue